import { render, staticRenderFns } from "./restSetting.vue?vue&type=template&id=1d6e2ac0&scoped=true&"
import script from "./restSetting.vue?vue&type=script&lang=js&"
export * from "./restSetting.vue?vue&type=script&lang=js&"
import style0 from "./restSetting.vue?vue&type=style&index=0&id=1d6e2ac0&lang=scss&scoped=true&"
import style1 from "./restSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e2ac0",
  null
  
)

export default component.exports